import { useEffect, useState } from "react";
import { API_BASE_URL } from "../../redux/services/apiConstant";

const ImageComponent = ({ src }) => {
    const [base64Image, setBase64Image] = useState('');


    const imageToBase64 = async (url) => {
        if (url) {
            const res = await fetch(API_BASE_URL + 'base64?link=' + url);
            const data = await res.json();
            return data?.response?.data?.image || '';
        }
        return '';
    };

    useEffect(() => {
        const fetchImage = async () => {
            const base64 = await imageToBase64(src);
            setBase64Image(base64);
        };

        fetchImage();
    }, []);

    console.log('base64Image', src);

    return base64Image && <img src={base64Image} alt="images" style={{ width: 180, height: 180, objectFit: 'contain' }} />;
};

export default ImageComponent;